import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import {
  a11yTokens,
  ensureContrast,
  AA_SURFACE,
  AA_LINK_ON_LIGHT,
} from '~/modules/Helper/contrast.helper';

function Theme({ children }) {
  const { highContrast, zoomFonte, corTema, corFonte } = useSelector(
    state => state.configuration
  );

  const corTemaAa = ensureContrast(
    corTema || AA_LINK_ON_LIGHT,
    AA_SURFACE,
    4.5,
    AA_LINK_ON_LIGHT
  );

  return (
    <ThemeProvider
      theme={{
        highContrast,
        zoomFonte,
        corTema: corTemaAa,
        corFonte,
        a11y: a11yTokens,
      }}
    >
      {children}
    </ThemeProvider>
  );
}

export default Theme;
